import { render, staticRenderFns } from "./ProgramsSingleResources.vue?vue&type=template&id=facbc4a0&"
import script from "./ProgramsSingleResources.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports